import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import { useEffect } from 'react';

function SelectBranchB () {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <div>
                        <Container>
                            <p>Books</p>
                <div className='row'>
                    <div className='col'>
                            <Link to='/Bcs'>
                                <div className="card" style={{width: 298}}>
                                  <img src="images/cs.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text">Computer Science</p>
                                    </div>
                                </div>
                            </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Bai'>
                            <div className="card" style={{width: 298}}>
                                <img src="images/ai.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text">Artificial Intelligence</p>
                                    </div>
                            </div>
                        </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Bme'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/me.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">Mechanical Engineering</p>
                                </div>
                        </div>
                        </Link>
                    </div>
                    <div className='col'>
                    <Link to='/Bce'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/ce.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">Civil Engineering</p>
                                </div>
                        </div>
                    </Link>
                    </div>
                </div>




                <div className='row'>
                    <div className='col'>
                        <Link to='/Bee'>
                                <div className="card" style={{width: 298}}>
                                  <img src="images/ee.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text"> Electrical Engineering</p>
                                    </div>
                                </div>
                        </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Bec'>
                            <div className="card" style={{width: 298}}>
                                <img src="images/ec.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text"> Electrical & Communication </p>
                                    </div>
                            </div>
                        </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Bit'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/it.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">IT</p>
                                </div>
                        </div>
                        </Link>
                    </div>
                    <div className='col'>
                    <Link to='/Bothers'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/others.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">Others</p>
                                </div>
                        </div>
                    </Link>
                    </div>
                </div>
                <br/> <br/> <br/> <hr/>
                <Footer/>
            </Container>    
        </div>
    );
}

export default SelectBranchB;
